import React, { useEffect } from'react';
import { useState,useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import IsLoginApi from 'Apis/IsLoginApi';
import {Navigate, Outlet} from "react-router-dom";
import{AppDispatch}from 'Stores/LangSetReducer';
import { useDispatch} from 'react-redux';
import MgpStore from "Stores/Store";


import GlbHdrUi from 'Views/Glb/GlbHdrUi';
const PrivateRoute = () => {
    const [loginInfo,setLoginInfo] =useState<any>("isLoading");
    const navigate = useNavigate();
  useEffect(()=>{
    IsLoginApi()
    .then((Resp) => {
      if(Resp.apiBody.login == true) {
        setLoginInfo("loginTrue");
      }else if (Resp.apiBody.login == false){
        setLoginInfo("loginFalse");
      }
    })
  },[])

    return (
      <>
       {loginInfo&&loginInfo == "loginFalse" ?
          navigate("/login",{replace:true})
          :
          <>
          <GlbHdrUi />
          <div className='privateWrap'>
              <Outlet />
          </div>
          </>

        }
        
      </>  
    );
}

export default PrivateRoute;